import { ActiveCampaignScript, CookieConsentScript, UserLinkScript } from '~/shared/scripts';

const USERLINK_CID = process.env.NEXT_PUBLIC_USERLINK_CID;
const USERLINK_DOMAIN = process.env.NEXT_PUBLIC_USERLINK_DOMAIN;

export default function DynamicScripts({ hideUserLink = false }: { hideUserLink?: boolean }) {
    const showUserLink = !hideUserLink && USERLINK_CID && USERLINK_DOMAIN;

    return (
        <>
            {showUserLink && <UserLinkScript cid={USERLINK_CID} domain={USERLINK_DOMAIN} />}
            <CookieConsentScript />
            <ActiveCampaignScript />
        </>
    );
}
